// Packages
import React from 'react';
import ModalImage from 'react-modal-image';
import Skeleton from 'react-loading-skeleton';
// Configuration
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
// Services
import { apiFetchData, apiFetchDataWithoutLangISO } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import disableElementService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/disableElementService';
import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    ACCOMMODATION_LINK_ABOVE_GUIDE_ARTICLE_CLICK,
    ARTICLE_SOCIAL_SHARE,
    ARTICLE_LAST_MINUTE_ITEM_SEE_ALL,
    ARTICLE_ACCOMMODATION_ITEM,
    ARTICLE_LAST_MINUTE_ITEM,
    ARTICLE_VIEW_LAST_MINUTE_ITEM,
    ARTICLE_ACCOMMODATION_ITEM_SEE_ALL,
    ARTICLE_VIEW_ACCOMMODATION_ITEM,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import userData from '@PROJECT_ROOT/assets/responsive-frontend/js/services/userData';
// Components
import BreadCrumbs from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/breadcrumbs';
import Carousel from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/carousel';
import FeaturedAccommodation from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/featuredAccommodation';
import StandardOfferAccommodation from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/StandardOfferAccommodation';
import StandardOfferAccommodationSkeleton from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/StandardOfferAccommodationSkeleton';
import LoginForMoreBenefits from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/LoginForMoreBenefits';
import SocialShare from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/socialShare';
import MainTitle from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/mainTitle';
import AxiosError from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/axiosError';
import { MdOutlineShare } from 'react-icons/md';

export default class GuideItemContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            publicResources: props.temporaryPublicResourcesSSR || props.publicResourcesSSR || null,
            accommodationOffersData: null,
            errorMsg: null,
            isLoading: false,
            initialUserWishlist: null,
            isLoginModalOpen: false,
            isLoadingSecondPart: true,
        };
        this.getData = this.getData.bind(this);
    }

    async componentDidMount() {
        const { publicResources, isLoading, initialUserWishlist } = this.state;
        this.user = userData.getDecodedUserDataFromLocalStorage();
        if (!publicResources) {
            await this.getData();
        } else if (!isLoading && !initialUserWishlist) {
            await this.getUserWishlistAndAccommodationOffersData();
        }
        this.addClickListenersToAccommodationLinks();
        disableElementService.removeServerSideRenderClass();
        window.isReactLoaded = true;
    }

    static getGuideItemID() {
        try {
            if (windowManipulationService.isBrowserEnvironment() && window.PageConfig && window.PageConfig.guideID) {
                return window.PageConfig.guideID;
            }

            reportError(new Error('Ne postoji window.PageConfig ili window.PageConfig.guideID u "getGuideItemID"'));
            return null;
        } catch (error) {
            reportError(new Error('Greška prilikom dohvata "guideID" u servisu "getGuideItemID":', error));
            return null;
        }
    }

    // TODO: Disable-ano samo zbog toga što je u planu refactor klasnih komponenti.
    // eslint-disable-next-line class-methods-use-this
    setWidthAndHeightToGallery = () => {
        const galleryWrapper = document.getElementById('galleryWrapper');
        const modalImage = galleryWrapper?.querySelector('.guide-item__modal-image');
        if (!modalImage) { return; }

        modalImage.setAttribute('width', '1275');
        modalImage.setAttribute('height', '850');
    };

    async getData() {
        const guideID = GuideItemContent.getGuideItemID();
        const supportedLocationIdPrefixes = ['pl-', 'ri-', 're-', 'lo-7', 'np-', 'beach-'];
        const isLocationId = supportedLocationIdPrefixes.some((prefix) => guideID.startsWith(prefix));
        this.setState({ isLoading: true, isLoadingSecondPart: true });
        Promise.all([
            apiFetchData(pageConfig.guideItemPage.initialPathExtension, `/${guideID}`),
            apiFetchData(pageConfig.guideItemPage.accommodationOffersPath, isLocationId ? `/${guideID}` : ''),
            this.user?.id && !IS_FRAME_SERVICE && apiFetchDataWithoutLangISO(pageConfig.homePage.userWishlistPath),
        ])
            .then(([mainResponse, accommodationOffersResponse, userWishlistResponse]) => {
                this.setState({
                    publicResources: mainResponse.data,
                    accommodationOffersData: accommodationOffersResponse.data,
                    initialUserWishlist: userWishlistResponse?.data ?? [],
                }, () => this.setWidthAndHeightToGallery());
            })
            .catch((err) => {
                this.setState({ errorMsg: err });
                reportError(err);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                    isLoadingSecondPart: false,
                });
            });
    }

    async getUserWishlistAndAccommodationOffersData() {
        const guideID = GuideItemContent.getGuideItemID();
        const supportedLocationIdPrefixes = ['pl-', 'ri-', 're-', 'lo-7', 'np-', 'beach-'];
        const isLocationId = supportedLocationIdPrefixes.some((prefix) => guideID.startsWith(prefix));
        this.setState({ isLoadingSecondPart: true });
        Promise.all([
            apiFetchData(pageConfig.guideItemPage.accommodationOffersPath, isLocationId ? `/${guideID}` : ''),
            this.user?.id && !IS_FRAME_SERVICE && apiFetchDataWithoutLangISO(pageConfig.homePage.userWishlistPath),
        ])
            .then(([accommodationOffersResponse, userWishlistResponse]) => {
                this.setState({
                    accommodationOffersData: accommodationOffersResponse.data,
                    initialUserWishlist: userWishlistResponse?.data ?? [],
                }, () => this.setWidthAndHeightToGallery());
            })
            .catch((err) => {
                this.setState({ errorMsg: err });
                reportError(err);
            })
            .finally(() => {
                this.setState({ isLoadingSecondPart: false });
            });
    }

    // TODO: Disable-ano samo zbog toga što je u planu refactor klasnih komponenti.
    // eslint-disable-next-line class-methods-use-this
    addClickListenersToAccommodationLinks = () => {
        const guideAccommodationLinkAboveElement = document.querySelector('.guide-accommodation-link-above');
        guideAccommodationLinkAboveElement?.addEventListener('click', () => {
            if (!IS_FRAME_SERVICE) dispatchTrackingEvent(ACCOMMODATION_LINK_ABOVE_GUIDE_ARTICLE_CLICK);
        });
    };

    render() {
        const { publicResources, isLoading, errorMsg, accommodationOffersData, initialUserWishlist, isLoginModalOpen, isLoadingSecondPart } = this.state;
        const shareURL = windowManipulationService.isBrowserEnvironment() && window.location.href;

        return (
            <>
                <BreadCrumbs breadcrumbs={publicResources?.breadcrumbs} breadcrumbsStructuredData={publicResources?.breadcrumbsStructuredData} isLoading={isLoading} skeletonMaxWidthPx={310} />
                {isLoading && (
                    <div>
                        <div className="row pageContent">
                            <div className="col-12">
                                <Skeleton width={200} height={30} />
                            </div>
                            <div className="col-md-12 aboutUsText">
                                <div className="mb-4 guide-item__skeleton-image">
                                    <Skeleton width="100%" />
                                </div>
                                <div className="mb-3">
                                    <Skeleton width={100} height={35} />
                                </div>
                                <Skeleton count={30} />
                                <div className="row">
                                    <h4 className="guide-item__read-more col-12">
                                        <Skeleton width={200} height={20} />
                                    </h4>
                                    <div className="col-md-12 aboutUsText card-group guide-item__card-group">
                                        {new Array(16).fill(null).map((item, index) => (
                                            <div className="guide-item__card-container guide-item__card-container-skeleton" key={index}>
                                                <Skeleton with="100%" />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {errorMsg && <AxiosError />}
                {publicResources && (
                    <>
                        <div>
                            <div className="row pageContent">
                                {publicResources.mainTitle && (
                                    <div className="guide-item__title-wrapper col-12">
                                        <MainTitle title={publicResources.mainTitle} />
                                        <SocialShare
                                            customButton={(
                                                <span className="social-share-wrapper d-flex justify-content-center align-items-center">
                                                    <MdOutlineShare size={20} />
                                                </span>
                                            )}
                                            shareURL={shareURL}
                                            socialShare={publicResources.socialShare}
                                            trackingEvents={{ onOpenModal: ARTICLE_SOCIAL_SHARE }}
                                        />
                                    </div>
                                )}
                                <div className="col-md-12 aboutUsText">
                                    {publicResources.mainImage === null ? (
                                        <Carousel data={publicResources.gallery} imageWidth={1275} imageHeight={850} />
                                    ) : (
                                        <ModalImage
                                            small={publicResources.mainImage.image.sourceURL}
                                            large={publicResources.mainImage.image.sourceURL}
                                            alt={publicResources.mainImage.image.altText}
                                            title={publicResources.mainImage.image.titleText}
                                            className="guide-item__modal-image"
                                        />
                                    )}
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: publicResources.articleHTMLContent,
                                        }}
                                    />
                                    {isLoadingSecondPart && <StandardOfferAccommodationSkeleton />}
                                    {accommodationOffersData?.standardOffers && (
                                        <StandardOfferAccommodation
                                            accommodation={accommodationOffersData}
                                            initialUserWishlist={initialUserWishlist}
                                            openLoginModal={() => this.setState({ isLoginModalOpen: true })}
                                            eventNames={{
                                                seeMoreClick: ARTICLE_ACCOMMODATION_ITEM_SEE_ALL,
                                                itemClick: ARTICLE_ACCOMMODATION_ITEM,
                                                itemView: ARTICLE_VIEW_ACCOMMODATION_ITEM,
                                            }}
                                        />
                                    )}
                                    {accommodationOffersData?.offers && (
                                        <FeaturedAccommodation
                                            accommodation={accommodationOffersData}
                                            initialUserWishlist={initialUserWishlist}
                                            openLoginModal={() => this.setState({ isLoginModalOpen: true })}
                                            eventNames={{
                                                seeMoreClick: ARTICLE_LAST_MINUTE_ITEM_SEE_ALL,
                                                itemClick: ARTICLE_LAST_MINUTE_ITEM,
                                                itemView: ARTICLE_VIEW_LAST_MINUTE_ITEM,
                                            }}
                                        />
                                    )}
                                    {publicResources.banner && (
                                        <div className="row">
                                            <div className="col-12 guideBanner">
                                                <a href={publicResources.banner.link.linkURL}>
                                                    <img
                                                        width="1275"
                                                        height="850"
                                                        src={publicResources.banner.backgroundImage.sourceURL}
                                                        alt={publicResources.banner.backgroundImage.altText}
                                                        title={publicResources.banner.backgroundImage.titleText}
                                                        loading="lazy"
                                                    />
                                                    <button type="button" className="guideBannerButton">{publicResources.banner.link.title}</button>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {publicResources.childItemLinks.length > 0 && (
                                        <div className="row">
                                            <h4 className="guide-item__read-more col-12">{publicResources.readMoreGuideItemsTitle}</h4>
                                            <div className="col-md-12 aboutUsText card-group guide-item__card-group">
                                                {publicResources.childItemLinks.map((item, index) => (
                                                    <div className="guide-item__card-container" key={index}>
                                                        <a className="guide-item__card-link" href={item.url}>
                                                            <div className="card guide-item__card">
                                                                <div className="guide-item__card-image-container">
                                                                    <img
                                                                        width="720"
                                                                        height="480"
                                                                        className="guide-item__card-image"
                                                                        src={item.thumbnail_image.sourceURL}
                                                                        alt={item.thumbnail_image.altText}
                                                                        title={item.thumbnail_image.titleText}
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                                <div className="card-body guide-item__card-body">
                                                                    <h4 className="guide-item__card-text">{item.title}</h4>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <LoginForMoreBenefits isLoginModalOpenOutsideControl={isLoginModalOpen} onModalClose={() => this.setState({ isLoginModalOpen: false })} />
                    </>
                )}
            </>
        );
    }
}
